<template>
  <div>
    <div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">CRUD de Agencias</h5>
            <button type="button" class="btn-close" @click="$emit('close')"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="guardarAgencia">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>Nombre</label>
                  <input v-model="agenciaEdit.nombre" class="form-control" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label>Dirección</label>
                  <input v-model="agenciaEdit.direccion" class="form-control" required />
                </div>
              </div>
              <div class="d-flex justify-content-end mb-3">
                <button type="button" class="btn btn-danger mx-2" @click="resetAgencia">Cancelar</button>
                <button type="submit" class="btn btn-primary">{{ editando ? 'Actualizar' : 'Agregar' }}</button>
              </div>
            </form>
            <div class="table-responsive mt-4">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Dirección</th>
                    <th class="col-acciones">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="agencia in paginar(agencias)" :key="agencia.id">
                    <td class="celda-entidad"><div class="entidad-nombre" :title="agencia.nombre">{{ agencia.nombre }}</div></td>
                    <td class="celda-entidad"><div class="entidad-nombre" :title="agencia.direccion">{{ agencia.direccion }}</div></td>
                    <td class="col-acciones">
                      <button class="btn-icon btn-icon-edit" @click="editarAgencia(agencia)" title="Editar" aria-label="Editar">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="btn-icon btn-icon-del" @click="eliminarAgencia(agencia.id)" title="Eliminar" aria-label="Eliminar">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!agencias.length" class="empty-row">
                    <td colspan="3">No se encontraron agencias</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <PaginacionListado :pagina="paginaActualDe(agencias)" :total-paginas="totalPaginasDe(agencias)"
              :total="agencias.length" :por-pagina="porPagina" :en-pagina="paginar(agencias).length"
              etiqueta="agencias" @cambiar="pagina = $event" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PaginacionListado from '@/components/PaginacionListado.vue';
import paginacionLocal from '@/mixins/paginacionLocal';
export default {
  name: 'CrudAgenciasModal',
  components: { PaginacionListado },
  mixins: [paginacionLocal],
  data() {
    return {
      agencias: [],
      agenciaEdit: {
        nombre: '',
        direccion: ''
      },
      editando: false,
      editId: null
    };
  },
  mounted() {
    this.getAgencias();
  },
  methods: {
    async getAgencias() {
      try {
        const res = await axios.get('/agencias');
        this.agencias = res.data;
      } catch (e) {
        console.error('Error al cargar agencias', e);
      }
    },
    async guardarAgencia() {
      try {
        if (this.editando) {
          await axios.put(`/agencias/${this.editId}`, this.agenciaEdit);
        } else {
          await axios.post('/agencias', this.agenciaEdit);
        }
        this.resetAgencia();
        this.getAgencias();
      } catch (e) {
        console.error('Error al guardar agencia', e);
      }
    },
    editarAgencia(agencia) {
      this.agenciaEdit = { ...agencia };
      this.editando = true;
      this.editId = agencia.id;
    },
    resetAgencia() {
      this.agenciaEdit = { nombre: '', direccion: '' };
      this.editando = false;
      this.editId = null;
    },
    async eliminarAgencia(id) {
      if (!confirm('¿Eliminar esta agencia?')) return;
      try {
        await axios.delete(`/agencias/${id}`);
        this.getAgencias();
      } catch (e) {
        console.error('Error al eliminar agencia', e);
      }
    }
  }
};
</script>

<style scoped>
.modal { display: block; }
</style>
